/** Boolesche Spalten der Bestellposition — Abschnitt „Booleans“ aus `IwmColumnsBestellposition`. */

import type { OrderPosition } from '@/types/entities';

import { CheckboxCell } from '../shared/CheckboxCell';
import type { CellTemplateMap } from '../types';
import { OrderPositionRowColor } from './OrderPositionRowColor';

export const orderPositionBooleanTemplates: CellTemplateMap<OrderPosition> = {
  Shipped: (model) => <CheckboxCell value={model.Shipped} />,
  PruefmusterQs: (model) => <CheckboxCell value={model.PruefmusterQs} />,
  PsiReleased: (model) => <CheckboxCell value={model.PsiReleased} />,
  LayoutErledigt: (model) => <CheckboxCell value={model.LayoutErledigt} />,
  KepVersand: (model) => <CheckboxCell value={model.KepVersand} />,
  Container_EingangErledigt: (model) => <CheckboxCell value={model.Container_EingangErledigt} />,
  KalkEkUebertragen: (model) => <CheckboxCell value={model.KalkEkUebertragen} />,

  // mit Zeilenfarbe
  Container_TerminBestaetigungCIF1: (model) => (
    <>
      <OrderPositionRowColor model={model} />
      <CheckboxCell value={model.Container_TerminBestaetigungCIF1} />
    </>
  ),
};

export default orderPositionBooleanTemplates;
